<template>
  <div class="yt-student-list">
 
    <GridTable
      v-if="stateFilterBySchool"
      ref="gridTable"
      id="StudentList"
      :key="componentKey"
      :title="`${title}${appendTitle || ''}`"
      urlPath="studentsCms"
      :columns="columns"
      :schema="schema"
      :supportAddNew="false"
      :hasEditItem="false"
      :hasDeleteItem="true"
      :defaultServerParams="{
        _fields:
          '_id,firstName,lastName,school._id,school.name,code,user.isActive,grade._id,grade.name,createdAt,learningMinutes,' +
          'tutor._id,tutor.isActive,tutor.subjects,tutor.teachingMinutes',
        schoolId: filteredBySchool,
        isDeleted: false,
        _sort: 'createdAt',
        _order: 'desc'
      }"
    >
      <template v-slot:customButtons="slotProps">
        <router-link
          :to="{
            name: 'StudentDetail',
            params: { id: slotProps.props.row._id }
          }"
          class="btn btn-success"
          >View</router-link
        >
      </template>
    </GridTable>
  </div>
</template>

<script>
import { Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

import BaseList from '@/components/BaseList'

const appModule = namespace('app')

@Component()
export default class StudentList extends BaseList {
  @appModule.State('schools') stateSchools
  @appModule.State('filterBySchool') stateFilterBySchool

  schema = null
  title = 'Users'

  ltHours(rowObj) {
    const learningMinutes = Math.round(rowObj.learningMinutes / 60)
    const teachingMinutes = Math.round(rowObj.teachingMinutes / 60)
    return `${learningMinutes}/${teachingMinutes}`
  }

  get columns() {
    return [
      {
        label: 'ID',
        field: '_id',
        hidden: true
      },
      {
        label: 'Active',
        field: 'user.isActive',
        type: 'switch'
      },
      {
        label: 'First Name',
        field: 'firstName',
        filterOptions: {
          enabled: true, // enable filter for this column
          placeholder: 'Filter by First Name', // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: 'keyup' // only trigger on enter not on keyup
        }
      },
      {
        label: 'Last Name',
        field: 'lastName',
        filterOptions: {
          enabled: true, // enable filter for this column
          placeholder: 'Filter by Last Name', // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: 'keyup' // only trigger on enter not on keyup
        }
      },
      {
        label: 'School',
        field: 'school.name',
        filterOptions: {
          enabled: true, // enable filter for this column
          placeholder: 'Filter by School', // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          filterDropdownItems:
            this.stateSchools.map(item => {
              return { value: item.id, text: item.name }
            }) || [], // dropdown (with selected values) instead of text input
          isMultiselect: true,
          fieldNameFilter: 'schoolId'
          // filterFn: this.columnFilterFn, // custom filter function that
          // trigger: 'keyup' // only trigger on enter not on keyup
        }
      },
      {
        label: 'Grade',
        field: 'grade.name',
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: 'Filter by Grade', // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          isMultiselect: true,
          fieldNameFilter: 'gradeId'
          // filterFn: this.columnFilterFn, // custom filter function that
          // trigger: 'keyup' // only trigger on enter not on keyup
        }
      },
      {
        label: 'Tutor',
        field: 'isTutor',
        formatFn: isTutor =>
          isTutor
            ? '<i class="fas fa-check-circle text-success"></i>'
            : '<i class="fas fa-minus-circle text-secondary"></i>',
        filterOptions: {
          enabled: true,
          placeholder: 'Filter by Tutor',
          //Disables the filter for this column
          filterValue: '',
          filterDropdownItems: [
            { value: true, text: 'Approved Tutors' },
            { value: false, text: 'Non-Approved Tutors' }
          ],
          isMultiselect: false,
          fieldNameFilter: 'activeTutor'
        }
      },
      // {
      //   label: 'Member Since',
      //   field: 'createdAt',
      //   type: 'date',
      //   dateInputFormat: 'YYYY-MM-DD', // expects 2018-03-16
      //   dateOutputFormat: 'MMM Do YYYY', // outputs Mar 16th 2018
      //   sortable: true
      // },
      // {
      //   label: 'L/T Hours',
      //   field: this.ltHours
      // },
      {
        label: 'Actions',
        field: 'actions'
      }
    ]
  }



}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/students/StudentList.vue